import { getNotificationRequest, getNotificationSucces, getNotificationFailer } from './notificationActions';
import DataService from '../../../../../Service';

interface INotification {
    created_at: any,
    crf_user_id: number,
    id: number,
    notifiable_id: number,
    notifiable_type: string,
    read_at: string | null,
    recipient_id: number,
    send_at: any,
    sender_id: number,
    title: string,
    updated_at: any
};

interface IApiRespons {
    read_notification: INotification[],
    success: boolean,
    unread_notification: INotification[]
};

export const fetchNotification = () => {
    return (dispatch: any) => {
        dispatch(getNotificationRequest());
        DataService.getData({}, "fetch_notication").then((response: IApiRespons) => {
            if (response?.success) {
                dispatch(getNotificationSucces(response));
            }
        }).catch((error) => {
            dispatch(getNotificationFailer(error));
        })
    }
}